import { createPortal } from "react-dom";
import { useModalStore } from "../../store/modalStore";
import { TermsModal } from "./TermsModal";

export function ModalRoot() {
  const { modals, close } = useModalStore();

  if (typeof document === "undefined") return null; // SSR 안전장치
  if (modals.length === 0) return null;

  return createPortal(
    <>
      {modals.map((m) => {
        const onClose = () => close(m.id);

        switch (m.type) {
          case "terms":
            return <TermsModal key={m.id} onClose={onClose} />;

          default:
            return null;
        }
      })}
    </>,
    document.body,
  );
}
